export {
    DeliveryDaysText,
    FOUR_TO_SEVEN_DAYS_CODES,
    isExtendedDelivery,
    SEVEN_TO_ELEVEN_DAYS_CODES,
} from './DeliveryDaysText';
